import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GlobalProvider } from '../../providers/global/global';
import { SetPoint } from '../../models/setPoint';

@IonicPage()
@Component({
  selector: 'page-set-point',
  templateUrl: 'set-point.html',
})
export class SetPointPage {

  setPoint = {} as SetPoint;
  data: Observable<any>;
  editVisible: boolean = false;
  isenabled: boolean = false;
  isenabled_tipoAlarme: boolean = false;
  isenabled_digital: boolean = false;
  datavalue: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public global: GlobalProvider, public alerCtrl: AlertController, public loadingCtrl: LoadingController) {

  }

  ionViewDidLoad() {
    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      duration: 10000
    });
    loader.present();
    this.datavalue = false;

    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/setpoint/get';
      this.global.check_jwt();

      let body = new FormData();
      body.append('tag', this.global.card_tag);
      body.append('db', this.global.banco);
      body.append('jwt', this.global.token);

      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        //console.log(data);
        if (data.erro != "Timeout")
        {
          document.getElementById("tag_setPoint").innerHTML = this.global.card_tag;
          this.setPoint.tipoAlarme = data[this.global.card_tag].tipoAlarme;
          this.setPoint.invertido = data[this.global.card_tag].invertido;
          this.setPoint.bandaMorta = data[this.global.card_tag].bandaMorta;
          this.setPoint.LL = data[this.global.card_tag].LL;
          this.setPoint.L = data[this.global.card_tag].L;
          this.setPoint.H = data[this.global.card_tag].H;
          this.setPoint.HH = data[this.global.card_tag].HH;
          this.setPoint.filtroTempo = data[this.global.card_tag].filtroTempo;
          if(this.global.securityLevel < 3){
            this.editVisible = true;
            this.isenabled_tipoAlarme = true;
            this.isenabled = (data[this.global.card_tag].tipoAlarme == 2) ? true : false;
            this.isenabled_digital = (data[this.global.card_tag].tipoAlarme == 0) ? false : true;
          }
        }
        else {
          alert(data.erro);
        }
      });
      
      loader.dismiss();
      this.datavalue = true;
    }
    catch (e) {
      console.error(e);
    }
  }

  changeAlarm() {
    this.isenabled = (this.setPoint.tipoAlarme == "2") ? true : false;
    this.isenabled_digital = (this.setPoint.tipoAlarme == "0") ? false : true;

    if (this.setPoint.tipoAlarme == "1") 
    {
      this.setPoint.bandaMorta = "0.5";
      this.setPoint.LL = "0";
      this.setPoint.L = "0";
      this.setPoint.H = "0";
      this.setPoint.HH = "0";
      this.isenabled = false;
      this.isenabled_digital = true;
    }
  }

  edit(setPoint: SetPoint) {
    let confirm = this.alerCtrl.create({
      title: 'Deseja realmente editar?',
      //message: '',
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Confirmar',
          handler: () => {
            console.log('Agree clicked');
            try {
              var url = 'http://iot.digicomp.com.br/api/public/ping/setpoint/set';
              this.global.check_jwt();

              let body = new FormData();
              body.append('db_client', this.global.banco);
              body.append('db','users');
              body.append('tabela','global_users');
              body.append('agent', this.global.userId);
              body.append('pass', this.global.password);
              body.append('tag', this.global.card_tag);
              body.append('bandaMorta', setPoint.bandaMorta);
              body.append('tipoAlarme', setPoint.tipoAlarme);
              body.append('invertido', setPoint.invertido)
              body.append('LL', setPoint.LL);
              body.append('L', setPoint.L);
              body.append('H', setPoint.H);
              body.append('HH', setPoint.HH);
              body.append('filtroTempo', setPoint.filtroTempo);
              body.append('jwt', this.global.token);

              this.data = this.http.post(url, body);
              this.data.subscribe(data => {
                //console.log(data);
                if (data.concluded == 0){
                  alert(data.erro);
                }
                else{
                  alert("Editado com sucesso!");
                }
                this.user_log(setPoint);                
              });
            }
            catch (e) {
              console.error(e);
            }
          }
        }
      ]
    });
    confirm.present()
  }

  user_log(setPoint: SetPoint)
  {
    this.global.operacao = "{"+'"'+"tag"+'"'+":"+'"' + this.global.card_tag +'"'+", "+'"'+"bandaMorta"+'"'+":" + setPoint.bandaMorta + ", "+'"'+"tipoAlarme"+'"'+":" + setPoint.tipoAlarme + ", "+'"'+"invertido"+'"'+":" + setPoint.invertido + ", "+'"'+"LL"+'"'+":" + setPoint.LL + ", "+'"'+"L"+'"'+":" + setPoint.L + ", "+'"'+"H"+'"'+":" + setPoint.H + ", "+'"'+"HH"+'"'+":" + setPoint.HH + ", "+'"'+"filtroTempo"+'"'+":" + setPoint.filtroTempo + "}";
    //console.log(this.global.operacao);
    try{
      var url='http://iot.digicomp.com.br/api/public/ping/global_users/log';
      this.global.check_jwt();

      let body=new FormData();
      body.append('db','users');
      body.append('tabela','users_log');
      body.append('agent', this.global.userId);
      body.append('client', this.global.banco);
      body.append('operacao', "setpoint_edit");
      body.append('detalhes', this.global.operacao);
      body.append('jwt', this.global.token);

      this.data=this.http.post(url,body);
      this.data.subscribe(data=>{
        //console.log(data);
      });
    }
    catch(e){
      console.error(e);
    }      
  }

}



// WEBPACK FOOTER //
// ./src/pages/set-point/set-point.ts